import { Box, Card } from '@mui/material';
import { styled } from '@mui/material/styles';
import { maxWidth } from '@mui/system';


const AuthStyledWrappers = styled(Box)(({ theme }) => ({
    height: '100%',
    padding: 0,
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: "#c8c8c8",
        borderWidth: "1px",
    },
    '& .MuiInputBase-input': {
        fontWeight: "normal !important",
        fontSize: "18px",
        padding: "16px 8px"
    },
    '& .mainContainer': {
        backgroundColor: theme.palette.primary.main,
        backgroundSize: "cover",
        overflow: "hidden",
        backgroundPosition: "center",
        // min-height (not height) so the page can grow and scroll when the on-screen keyboard
        // shrinks the viewport, instead of the footer link sliding over the form.
        boxSizing: "border-box",
        minHeight: "100vh",
        "@supports (min-height: 100dvh)": {
            minHeight: "100dvh",
        },
        marginTop: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "column",
        "& .content": {
            display: "inline-flex",
            flexDirection: "column",
            gap: "2px",
            alignItems: "center",
            flex: "1 0 auto",
            justifyContent: "center",
            width: "100%",
            maxWidth: "450px",
        },
        "& .heading": {
            fontSize: '28px',
            color: theme.palette.text.secondaryLight,
            textAlign: "center",
            margin: '20px 0px',
            fontWeight: "600",
            '@media (min-width:475px)': {
                fontSize: '32px'
            },

        },
        "& .pera": {
            fontSize: '15px',
            textAlign: "center",
            color: theme.palette.text.secondary,
        },


        "& .otpContainer": {
            display: "flex",
            gap: "5px",
            justifyContent: "space-between",
            marginBottom: "5px",
            [theme.breakpoints.up('sm')]: {
                gap: '10px',
            },

        },
        "& .otpInput": {
            border: "1px solid #c4c4c4",
            width: "54px !important",
            height: "54px !important",
            fontSize: "25px",
            borderRadius: "5px",
            '@media (min-width:475px)': {
                width: "60px !important",
                height: "60px !important",
                fontSize: "24px",
            },

        },

        "& .underLineText": {
            color: theme.palette.text.secondary,
            fontSize: '14px',
            [theme.breakpoints.up('sm')]: {
                fontSize: '16px',
            },
            cursor: 'pointer',
            textDecoration: 'underline',
        },
        "& .footerText": {
            color: theme.palette.text.secondary,
            margin: '0px 2px',
            fontSize: '14px',
            [theme.breakpoints.up('sm')]: {
                fontSize: '16px',
            },

        },
        // In the normal flow (not absolutely positioned) so it always stays below the form,
        // even while the keyboard is open. Bottom spacing matches the old 50px / 70px offset.
        "& .footerBox": {
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            paddingTop: 24,
            paddingBottom: 34,
            [theme.breakpoints.up('sm')]: {
                paddingBottom: 54,
            },
        },

    },
    '& img[alt="heartpng"] ': {
        display: "flex",
        width: 105,
        animation: " heartbeat 1.2s infinite",
    },

    "@keyframes heartbeat": {
        "0%": {
            transform: "scale(1)",
        },
        "25%": {
            transform: "scale(0.9)",
        },
        "60%": {
            transform: "scale(1.1)",
        },
        "100%": {
            transform: "scale(1)",
        }
    },
}));

const CardStyledWrappers = styled(Card, {
    shouldForwardProp: (prop) => prop !== 'componentType' && prop !== 'statusType',
})(({ theme, componentType = "", statusType = "" }) => {
    const statusBg = (statusType == "progress" || statusType == "In progress") ? theme.palette.secondary.light : statusType == "completed" ? theme.palette.primary.lightest : statusType == "canceled" ? theme.palette.error.light : ''
    const statusColor = (statusType == "progress" || statusType == "In progress") ? theme.palette.secondary.main : statusType == "completed" ? theme.palette.primary.light : statusType == "canceled" ? theme.palette.error.main : ''
    const statusBackground = (statusType == "progress" || statusType == "In progress") ? theme.palette.gradient.highlight(theme.palette.secondary.main) : statusType == "completed" ? theme.palette.gradient.highlight(theme.palette.success.main) : statusType == "canceled" ? theme.palette.gradient.highlight(theme.palette.error.main) : ''
    return {
        borderRadius: "18px",
        border: statusBackground ? "1px solid transparent" : `1px solid ${theme.palette.border.light}`,
        background: statusBackground,
        padding: "16px 12px",
        boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
        overflow: "visible",

        "& > .cardBody": {
            ...(componentType == "Rides"
                ? { position: "relative", } : {

                    display: "flex",
                    alignItems: "center",
                    gap: '12px',
                    position: "relative",
                    scrollbarWidth: 'none',   // Firefox
                    msOverflowStyle: 'none',  // IE / Edge
                    '&::-webkit-scrollbar': {  // Chrome / Safari
                        display: 'none',
                    },
                }
            ),
            "& .cardContent": {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 1,
                width: "100%",
            },
            "& .cardMedia": {
                width: 40,
                height: 40,
                borderRadius: 12,
                objectFit: "contain",
                backgroundColor: theme.palette.border.light,
            },
            "& .cardOverlay": {
                position: "absolute",
                right: 0,
                top: 0,
            },
            "& .cardProgress": {
                height: '7px',
                borderRadius: '18px',
                marginTop: "3px",
            },
            "& .cardChip": {
                fontWeight: 500,
                fontSize: '0.75rem',
                // zIndex: 1000,
                backgroundColor: statusBg,
                display: 'flex',
                color: statusColor,
                gap: '2px',
                padding: '4px 8px',
                borderRadius: '20px !important',
            },

        },
    }
})



export const AuthRootWrapper = ({ children }) => {
    return <AuthStyledWrappers p={2}>{children}</AuthStyledWrappers>;
};
export const CardRootWrapper = ({ children, componentType = "", statusType = "", ...props }) => {
    return <CardStyledWrappers componentType={componentType} statusType={statusType} {...props}>{children}</CardStyledWrappers>;
};

